
 <template>
  <div class="wallBox largeScreen-homePage editTarget-largeScreen-homePage"
    :style="{ backgroundImage: 'url(' + skinList[skinIndex].bg + ')' }">
    <div class="full-body" style="" @click="fullHandle">
      <div class="body">
        <div class="vdrStatic"
          style="top: 72px;left: 137px;z-index: 21;background-size: 100% 100% !important;width: 102px;height: 103px;"
          :style="{ backgroundImage: 'url(' + require('@/assets/image/logo.png') + ')' }"></div>
        <div class="vdrStatic"
          style="top: 76px;left: 261px;z-index: 21;font-size: 26px;color: rgb(246, 243, 255);text-shadow: rgba(255, 255, 255, 0) -1px -1px 0px,rgba(255, 255, 255, 0) 0px -1px 0px,rgba(255, 255, 255, 0) 1px -1px 0px,rgba(255, 255, 255, 0) 1px 0px 0px,rgba(255, 255, 255, 0) 1px 1px 0px,rgba(255, 255, 255, 0) 0px 1px 0px,rgba(255, 255, 255, 0) -1px 1px 0px,rgba(255, 255, 255, 0) -1px 0px 0px;min-width: 320px;height: 103px;">
          <div class="myEditText" >活动主题：{{detail.name}}</div>
          <div class="myEditText" v-if="detail.organizer">主办单位：{{ detail.organizer }}</div>
          <div class="myEditText" v-else>主办单位：<span v-if="detail.create_user"> {{  detail.create_user.username }}</span> </div>
        </div>
        <div class="vdrStatic"
          style="top: 94px;left: 567px;z-index: 21;font-size: 40px;color: rgb(246, 243, 255);text-shadow: rgba(255, 255, 255, 0) -1px -1px 0px,rgba(255, 255, 255, 0) 0px -1px 0px,rgba(255, 255, 255, 0) 1px -1px 0px,rgba(255, 255, 255, 0) 1px 0px 0px,rgba(255, 255, 255, 0) 1px 1px 0px, rgba(255, 255, 255, 0) 0px 1px 0px,rgba(255, 255, 255, 0) -1px 1px 0px,rgba(255, 255, 255, 0) -1px 0px 0px;min-width: 1100px;height: 41px;">
          <div class="myEditText" style="text-align:center;" v-if="detail.prize_type == 1">{{ openTimeText }}</div>
          <div class="myEditText" style="text-align:center;" v-if="detail.prize_type == 2">{{ openPrizeNumText }}</div>
          <div class="myEditText" style="text-align:center;" v-if="detail.prize_type == 3">手动开奖</div>
        </div>
        <div class="vdrStatic JS_SoundHander" style="top: 197px;left: 1693px;z-index: 21;width: 90px;height: 90px;">
          <div class="soundBox  pointerDom" :class="musicPlay == true ? 'soundPlay' : 'soundOff'" @click="musicClick">
          </div>
        </div>
        <div class="vdrStatic pointerVdr JS_WinListHander" @click="showWinListHander"
          style="top: 328px;left: 1693px;z-index: 21;background-size: 100% 100% !important;width: 92px;height: 110px;"
          :style="{ backgroundImage: 'url(' + require('@/assets/image/winningList.png') + ')' }"></div>
        <div>
         <div class="vdrStatic pointerVdr JS_ShowQrcodeHander"
            style="top: 478px;left: 1693px;z-index: 21;background-size: 100% 100% !important;width: 92px;height: 110px;"
            @click="fetchQrcode" v-if="showQcode == false"
            :style="{ backgroundImage: 'url(' + require('@/assets/image/showQrCode.png') + ')' }"></div>
           <div
            class="myEditElement pointerDom largeScreen-qrCodeBtn-1 editTarget-largeScreen-qrCodeBtn-1 JS_HideQrcodeHander"
            style="width: 92px; height: 110px; left: 1693px; top: 478px" @click="showQcode = false"
            v-if="showQcode == true"
            :style="{ backgroundImage: 'url(' + require('@/assets/image/hideQrCode.png') + ')' }">
          </div>
          <div
            class="myEditElement pointerDom largeScreen-qrCodeBtn-1 editTarget-largeScreen-qrCodeBtn-1 JS_HideQrcodeHander"
            style="width: 92px; height: 110px; left: 1693px; top: 628px" @click="changeSkin"
            :style="{ backgroundImage: 'url(' + require('@/assets/image/changeSkin.png') + ')' }">
          </div> 
        </div>
        <div class="lottery-box flex flex-pack-justify flex-align-center showPage">
          <div class="vdrStatic" style="top: 198px;left: 139px;z-index: 20;width: 400px;height: 720px;">
            <div class="awardInfo">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="width: 260px" v-for="(item, index) in detail.detail" :key="item.id"
                  >
                    <div class="awardStyleBox flex flex-pack-center flex-align-center">
                      <span class="awardStyle">{{ item.name }}</span>
                    </div>
                    <!-- <div class="awardNameBox flex flex-pack-center flex-align-center">
                      <span>{{ item.desc }}</span>
                    </div> -->
                    <div class="awardImgBox">
                      <img :src="item.cover != '' ? item.cover :'https://static.goubudian.com/Uploads/lottery/2511/6909a111d7e3c.png'" />
                    </div>
                    <div class="awardAmountBox ellipsis" v-if="detail.show_prize_num == 1">奖品数量： {{ item.num }}</div>
                  </div>
                </div>
              </div>
              <div class="awardJoinNumBox flex flex-pack-center flex-align-center">
                <span class="tip">已参加抽奖人数</span>
                <span class="awardJoinNum ellipsis">{{ detail.total_join_num }}</span>
                <span title="刷新" class="refreshJoinNum" @click="refeshDetail()"></span>
              </div>
             
            </div>
          </div>
          <div class="vdrStatic" style="top: 198px;left: 567px;z-index: 20;width: 1100px;height: 720px;">

            <div class="lotteryScreen">
              <!--参与人界面，未开奖时-->
              <template v-if="(detail.prize_type == 3 && (status==0 || status == 2 )) || detail.prize_type < 3">
                <div>
                  <div class="lottery-screen flex flex-wrap flex-align-start" v-if="detail.join_user_list.length>0">
                    <div class="comment-zone largeScreenScrollBox" id="winBoxScroll" ref="winBoxScroll">
                      <ul class="flex flex-wrap flex-align-start" ref="winBoxScrollUl">
                        <li class="cell flex" v-for="(item, index) in detail.join_user_list" :key="index">
                          <img :src="item.avatar" />
                          <span>{{ item.username }}</span><span v-if="item.create_time">，{{item.create_time}} &nbsp;参与抽奖</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="lottery-screen flex flex-wrap flex-align-center" v-if="detail.join_user_list.length == 0">
                      <div class="rolling-zone flex-align-center">
                        <ul class="flex flex-j-sa flex-align-center" ref="winBoxScrollUl">
                          <li class="cell flex flex-v flex-pack-center flex-align-center one">
                            <div class="lottery-item one">
                              <div class="headBox flex flex-pack-center flex-align-center">
                                <div class="headImg lottery-ani-box">
                                  <div class="item">
                                    <img :src="require('@/assets/image/defHeadImg_join.png')" class="headImgSrc">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                  </div>
                </div>
              </template>
              <!--参与人界面，未开奖时-->

               <!--参与人界面，未开奖时-->
              <div v-if="detail.prize_type == 3 && status == 1">
                <div class="lottery-screen flex flex-wrap flex-align-center">
                <div class="prize_title" > 
                  <span v-if="showtitle"> <span  v-if="prizetitle">本次抽取奖品：{{prizetitle}}</span> <span v-else>等待主持人开奖 </span></span>
                  <span v-if="!showtitle&&isTipsEnd==false&&manualDetail.name!=undefined">{{manualDetail.name}}:共{{manualDetail.num}}个,已抽{{manualDetail.hasnum}}个,本轮抽{{manualDetail.pernum}}个</span>
                  <span v-if="!showtitle&&isTipsEnd==true&&manualDetail.name!=undefined">{{manualDetail.name}}:共{{manualDetail.num}}个,已抽完</span>
                </div>
                <div class="rolling-zone flex-align-center">
                  <ul class="flex flex-j-sa flex-align-center" v-if="rollUsers.length == 0">
                    <li class="cell flex flex-v flex-pack-center flex-align-center one">
                      <div class="lottery-item one">
                        <div class="headBox flex flex-pack-center flex-align-center">
                          <div class="headImg lottery-ani-box">
                            <div class="item">
                              <img src="//hd.faisys.com/version2/image/largeScreen/xccjScreen/defHeadImg.png" class="headImgSrc">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="headUserName">等待主持人开始抽奖</div>
                    </li>
                  </ul>
                   <ul class="flex flex-j-sa flex-align-center" v-if="rollUsers.length > 0">
                    <template v-if="manualDetail.num>2">
                        <li class="cell flex flex-v flex-pack-center flex-align-center" :class="rollUsers.length>3?'tree':(rollUsers.length>1?'two':'one')"  v-for="(item,index) in rollUsers" v-if="index<3">
                          <div class="lottery-item one">
                            <div class="headBox flex flex-pack-center flex-align-center">
                              <div class="headImg lottery-ani-box">
                                <div class="item">
                                  <img :src="item.avatar" class="headImgSrc">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="headUserName"> {{ item.username }}</div>
                        </li>

                    </template>
                    <template v-if="manualDetail.num==2">
                       <li class="cell flex flex-v flex-pack-center flex-align-center" :class="rollUsers.length>2?'two':'one'"  v-for="(item,index) in rollUsers" v-if="index<2">
                          <div class="lottery-item one">
                            <div class="headBox flex flex-pack-center flex-align-center">
                              <div class="headImg lottery-ani-box">
                                <div class="item">
                                  <img :src="item.avatar" class="headImgSrc">
                                </div>
                              </div>
                            </div>
                          </div>
                           <div class="headUserName"> {{ item.username }}</div>
                        </li>
                    </template>
                     <template v-if="manualDetail.num==1">
                       <li class="cell flex flex-v flex-pack-center flex-align-center one">
                          <div class="lottery-item one">
                            <div class="headBox flex flex-pack-center flex-align-center">
                              <div class="headImg lottery-ani-box">
                                <div class="item">
                                  <img :src="rollUsers[0].avatar" class="headImgSrc">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="headUserName"> {{ rollUsers[0].username }}</div>
                        </li>
                    </template>
                  </ul>
                </div>
              </div> 
               <!--参与人界面，未开奖时-->
  
            </div>
             
              <div v-if="detail.prize_type == 3">
                <template v-if="status==0&&isShowBtn">
                   <div class="vdrStatic pointerVdr largeScreen-lotteryBtn" @click="firstStart" v-if="isfirst" >进入抽奖</div>

                </template>

                <template v-else-if="status>0&&isShowBtn">
                  	<!--停止-->
                    <div class="vdrStatic pointerVdr largeScreen-lotteryBtn" name="停止" @click="stop_CJ" v-if="isdoing==true">停止</div>
                    
                    <div class="vdrStatic pointerVdr largeScreen-lotteryBtn"  name="立即开奖" @click="startPrize('continue')" v-if="ismidend==false&&isallend==false&&isContinue==false&&!isdoing&&!isShowRoll" >开始抽奖</div>
                    
                    
                    <div  class="vdrStatic pointerVdr largeScreen-lotteryBtn"  name="滚动" @click="begin_CJ" v-if="isShowRoll&&!isdoing">开奖</div>
                    
                    <!-- 开始抽奖 -->
                                                                              
                    <div class="vdrStatic pointerVdr largeScreen-lotteryBtn" name="立即开奖" @click="startPrize" v-if="ismidend==true&&isallend==false&&isContinue==false&&!isdoing">继续开奖</div>
                    
                    <div class="vdrStatic pointerVdr largeScreen-lotteryBtn" name="继续抽奖" @click="continuePrize" v-if="ismidend==true&&isallend==false&&isContinue==true&&!isdoing">继续开奖</div>
                  
                    <div class="vdrStatic pointerVdr largeScreen-lotteryBtn" name="查看全部" @click="seeALL" v-if="isallend==true&&!showWinner">{{btnName}}</div>

                </template>

                <template  v-else-if="status==2&&!isShowBtn&&!showWinner">
                  <div class="vdrStatic pointerVdr largeScreen-lotteryBtn" name="查看全部" @click="seeALL" >查看中奖名单</div>

                </template>
               
              </div>
            </div>
           
          </div>
          <VueDragResize v-if="showQcode" :isActive="true" :w="480" :h="550" :minw="50" :minH="50" :x="left" :y="top"
            :gridX="20" :gridY="20" :aspectRatio="true" :parentLimitation="true" :aspect-ratio="true" :isResizable="true"
            :isDraggable="true" v-on:resizing="resize" v-on:dragging="resize" :sticks="['tm', 'bm', 'ml', 'mr']"
            :stickSize="12" :z="999">
            <div class="qr-code-box" style="{borderRadius: 21 * qrCodeScale + 'px', padding: 44 * qrCodeScale + 'px'}"
              :style="{ borderRadius: 21 * qrCodeScale + 'px', padding: 44 * qrCodeScale + 'px', width: +width + 'px', height: +height + 'px' }">
              <div class="qrCodeContent flex flex-pack-center flex-align-center">
                <img :src="ewm" />
              </div>
              <div class="qrCodeTip" :style="{
                fontSize: 30 * qrCodeScale + 'px',
                marginTop: 39 * qrCodeScale + 'px'
              }">
                扫描二维码参与互动大屏幕
              </div>
            </div>
          </VueDragResize>

      </div>
        <!---->
        <div class="audioCtrl">
          <audio id="player" controls="controls" ref="player" loop="loop">
            <source src="@/assets/image/bg_music.mp3" />
          </audio>
        </div>
      </div>
    </div>

    <div class="largeScreenPopup winning-list-box" v-show="showWinList">
      <div class="popupContent winning-list showPage">
        <div class="closeRank JS_CloseWinlist" @click="hideWinListHander"></div>
        <div class="winningListBase">
          <div class="winningListContent largeScreenScrollBox">
            <div class="winningItem" v-for="(item, index) in winLists" :key=item.id>
              <div class="awardLevel">{{ item.name }} × {{ item.prize_num }}人中奖 <span>{{item.prize_num_last>0?'剩余'+item.prize_num_last+'份':'已抽完'}}</span></div>
              <div class="playerList flex flex-wrap" v-if="item.prize_user_list.length > 0">
                <div class="playerItem" v-for="(citem) in item.prize_user_list" :key="citem.id">
                  <div class="headImgBox flex flex-pack-center flex-align-center">
                    <img :src="citem.avatar" class="headImg" />
                  </div>
                  <div class="name ellipsis">{{ citem.username }}</div>
                </div>
              </div>
              <div class="morePlayer" @click="MoreWinListHander(item, index)"
                v-if="item.fetch === false">加载更多>></div>
              <div class="playerList flex flex-wrap" v-if="item.prize_user_list.length == 0">
                <div class="noData">暂无人中奖</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="largeScreenPopup winning-list-box" v-show="(iskj || isuserkj) && showWinSmallList">
      <div class="popupContent winning-list showPage">
        <div class="closeRank JS_CloseWinlist" @click="closeKJ"></div>
        <div class="winningListBase">
          <div class="winningListContent largeScreenScrollBox">
            <div class="winningItem" v-for="item in winUser" :key=item.id>
              <div class="awardLevel">恭喜以下人员抽中：{{manualDetail.name}}</div>
              <div class="playerList flex flex-wrap" v-if="winUser.length > 0">
                <div class="playerItem" v-for="(citem) in winUser" :key="citem.id">
                  <div class="headImgBox flex flex-pack-center flex-align-center">
                    <img :src="citem.avatar" class="headImg" />
                  </div>
                  <div class="name ellipsis">{{ citem.username }}</div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>

    <audio id="Running" loop :src="require('@/assets/image/runingMusic.mp3')"></audio>
    <audio id="Winning"  :src="require('@/assets/image/winMusic.mp3')"></audio>
    <audio id="Winover" loop :src="require('@/assets/image//winOver.mp3')"></audio>

    <div class="skillSupport flex flex-pack-center flex-align-center" style="zoom: 1.05">
      页面技术由大转盘抽奖工具提供
    </div>
    <LoginBox ref="login"></LoginBox>
    <div class="skin_mask" v-show="skinDIYShow"></div>
    <div class="skinBox" v-show="skinDIYShow">
      <div class="skinItems">
        <div class="skinItem"  v-for="(item,index) in skinList" :key="item.id" :class="index == skinIndex?'active':''" @click="setSKinHander(index)">
          <div class="imgbox">
            <img :src="item.bg" alt="">
          </div>
          <div class="title">{{item.title}}</div>
        </div>
        <div class="skinItem">
          <div class="imgbox">
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="baseUrl+'file.html'"
              :on-success="handleUploadSuccess"
              >
              <img src="@/assets/image/diy_img.png" alt="">
            </el-upload>
          </div>
          <div class="title">上传自定义皮肤</div>
        </div>
      </div>
      <div class="closeBtn" @click="skinCloseHander">
        <img src="@/assets/image/lotteryRankClose.png" />
      </div>
    </div>
  </div>
</template> 

<script>
import { getGroupLotteryDetail, baseUrl, getPrizeList, getPrizePage, getQcode, getDZPSkinList, getPrizeReady,postPrizeRun,postPrizeAfter } from '../api/api'
import $ from 'jquery'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import VueDragResize from 'vue-drag-resize'
import io from 'socket.io-client'
import LoginBox from './loginBox.vue'

export default {
  name: 'normalDetail',
  data: () => ({
    showWinList: false,
    showQcode: false,
    swiper: '',
    width: 480,
    height: 550,
    top: 0,
    left: 0,
    qrCodeScale: 1,
    now: 0,
    timer: null,
    timer2: null,
    timer3:null,
    detail: {},
    winLists: [],
    ewm: '',
    socket: io('wss://wss.zjjunlv.com'), // socket
    isconnect: false,
    wins: [],
    skinDIYShow: false,
    musicPlay: false,
    skinIndex: 0,
    skinList: [{
      'id': '1',
      'title': '钱多多',
      'uid': '0',
      'bg': 'https://static.goubudian.com/Uploads/lottery/2305/6465c7f2d309e.png'
    }],
    baseUrl: baseUrl,
    status:0,
    isShowBtn:true,
    showtitle: true, //是否显示奖项标题
		prizetitle: '', //奖项标题
		isfirst: true, //是否第一次进入开奖true 还是继续开奖false 
    showWinner:false,
    iskj: false, //参与者弹窗
    isuserkj: false, //参与者弹窗

    ismidend: false, //当前抽奖结束

    isContinue: false, //是否接着开奖

    isTipsEnd: false, //是否已经结束当前分次的开奖，开始下一个奖

    isdoing: false, //正在滚动抽奖中

    isallend: false, //所有抽奖结束

    btnName: '开始抽奖', //按钮名次
    manualDetail: {},//手动开奖对象
		isShowRoll:false, //web端是否显示停止
    isCreator:0,
    rollUsers:[],
    rolltimer:null,
    isfatch:false,
    winUser:[],
    showWinSmallList:false,
  }),
  components: {
    VueDragResize,
    LoginBox
  },
  computed: {
    openPrizeNumText(){
       console.log('openPrizeNumText');
       const auto_prize_num = this.detail.auto_prize_num
       const prize_type = this.detail.prize_type
       if(prize_type != 2){
        return ''
      }
      const diff = auto_prize_num - this.detail.total_join_num
      if(diff <= 0){
        console.log('diff <= 0');
        if(this.detail.status == 2){
          console.log('status == 2');
          this.showWinListHander();
          clearInterval(this.timer3)
          return '已开奖'
        } else{
          console.log('status != 2 getGroupLotteryDetail');
          getGroupLotteryDetail({lid:this.lottery_id}, this.$cookie.getCookie('token')).then(res => {
            console.log(res);
            if(res.code == 200){
              this.detail.status  = res.data.status;
              if( this.detail.total_join_num != res.data.total_join_num){
                console.log('总参与人数于实际参与人数不符合，更新总参与人数')
                this.detail.total_join_num = res.data.total_join_num;

              }
     

              if(res.data.status == 2){
               console.log('clearTimeout timer3');
               clearTimeout(this.timer3);
              }
            }
          })
          return '正在开奖,请稍等......'
        }

      }
      else{
        console.log('diff > 0');
        return `满${ this.detail.auto_prize_num}自动开奖，距离开奖还剩：${diff}人`;

      }

    },
    openTimeText() {
      console.log('openTimeText');
      const ts = this.detail.auto_prize_time
      if (!ts) return ''
      const prize_type = this.detail.prize_type
      if(prize_type != 1){
        return ''
      }
      const diff = ts - this.now
      const pad = (n) => (n < 10 ? '0' + n : n)
      // 开奖时间大于 12 小时，正常显示年月日时分秒
      if (diff > 12 * 3600) {
        const d = new Date(ts * 1000)
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}自动开奖`
      }
      // 已到开奖时间
      if (diff <= 0) {
        console.log('diff <= 0');
        if(this.detail.status == 2){
          console.log('status == 2');
          this.showWinListHander();
          clearInterval(this.timer)
          return '已开奖'
        }
        else{
          console.log('status != 2 getGroupLotteryDetail');
          getGroupLotteryDetail({lid:this.lottery_id}, this.$cookie.getCookie('token')).then(res => {
            console.log(res);
            if(res.code == 200){
              this.detail.status  = res.data.status;
              if(res.data.status == 2){
                console.log('clearTimeout timer2');
                clearTimeout(this.timer2);
              }
            } else {
              this.$message && this.$message.error(res.msg)
            }
          }).catch(err => {
            console.error('getGroupLotteryDetail error', err)
          })

          return '正在开奖,请稍等......'
        }
      }
      // 小于 12 小时，启动倒计时
      const h = Math.floor(diff / 3600)
      const m = Math.floor((diff % 3600) / 60)
      const s = diff % 60
      return `距离开奖还剩：${h}小时${pad(m)}分${pad(s)}秒`
    }
  },
  methods:{
      closeKJ(){
        this.iskj=false;
        this.isuserkj=false;
        this.showWinSmallList= false;
        this.isShowBtn = true;
        this.rollUsers = [];
      },
      firstStart(){
        getPrizeReady({lid:this.lottery_id}, this.$cookie.getCookie('token')).then(res=>{
         
        
           if (res.data.code == 200) {
            this.prizetitle=res.data.data.name;
            this.manualDetail = res.data.data;
            this.iskj = true;
            this.btnName = '立即开始';
            this.status=1;
           }
        })
		 },
     	//继续抽奖
		  continuePrize() {
		    this.startPrize('continue');
		  },
     //开始抽奖
			startPrize(type) {

				$("#Running")[0].pause();
		   	$("#Winning")[0].pause();

				postPrizeRun({
					lid: this.lottery_id,
				},this.$cookie.getCookie('token')).then(res => {
          console.log(res);
					if(res.data.code == 200) {
            this.manualDetail.users = res.data.data.users;
						this.isCreator=1;
						this.manualDetail = this.manualDetail;
						this.prizetitle =this.manualDetail.name;
						this.iskj = false;
						this.ismidend = false;
						this.isfirst = false;
						this.showtitle = true;
						this.status=1;
						this.isShowRoll=true;
						if(this.isfirst) {
							this.btnName = '开始抽奖';
						} else {
							this.isTipsEnd = false;
						};
						
						
						// 发送通知
						var obj = res.data.data;
						obj.prizetitle = this.manualDetail.name;
						obj.btnName = '等待主持人开奖';
						obj.showtitle = true;
						obj.runs = 1;
						obj.ismidend = false;
						obj.isdoing = false;
						obj.isContinue = this.isContinue;
						obj.isTipsEnd = this.isTipsEnd;
						this.pushCS(obj);
						if(type == "continue") {
						this.begin_CJ();
						}
					}
					else if(res.data.code == 420) {
						const h = this.$createElement;
						this.$msgbox({
				          title: '提示',
				          message: h('p', null, [
				            h('p', null, res.data.msg),
				            h('p', null, '每个活动只能选择一类终端（手机或电脑）开奖'),
				          ]),
					      confirmButtonText: '知道了',
				          callback: action => {
				          }
				      });
					}
					else {
						 const h = this.$createElement;
				        this.$msgbox({
				          title: '提示',
				          message: h('p', null, [
				            h('p', null, '参与人数不足，无法开奖！请尝试以下操作：'),
				            h('p', null, '1.继续邀请更多参与者'),
				            h('p', null, '2.进入活动编辑界面，减少奖品份数')
				          ]),
				          showCancelButton: true,
					      confirmButtonText: '知道了',
					      cancelButtonText: '编辑活动',
				          callback: action => {
				          	if (action === 'cancel') {
				          		this.$router.push('/create/create/'+this.id);
				          	}
				          }
				       });
					}
				},reject=>{
          console.log(reject);
          						 const h = this.$createElement;
				        this.$msgbox({
				          title: '提示',
				          message: h('p', null, [
				            h('p', null, reject.data.msg),
				          ]),
				          showCancelButton: false,
					        confirmButtonText: '知道了',
				       });
        })
			},
      //开始抽奖滚动
			begin_CJ() {
				setTimeout(function () {
				  $("#Running")[0].currentTime=0;
					$("#Running")[0].play();
				 }, 150);
				
				this.showtitle = false;
				this.isdoing = true;
        // this.manualDetail.users 每0.05秒随机排序打乱 
        this.rollWinusers(this.manualDetail.users);
        //to Doing
				// 发送通知
				var obj = {
					ismidend: false,
					isdoing: true,
					showtitle: false,
					runs: 2, //
					btnName: '正在抽奖中',
				}
				this.pushCS(obj);
			},
      rollWinusers(users) {
        if (!users || !users.length) return
        // 复制一份，避免打乱原 manualDetail.users
        const list = users.slice()
        // 每 0.05 秒（50ms）随机打乱一次
        this.rolltimer = setInterval(() => {
          // Fisher-Yates 洗牌，保证均匀随机
          for (let i = list.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            const tmp = list[i]
            list[i] = list[j]
            list[j] = tmp
          }
          // 生成新数组引用，触发 Vue 响应式重渲染
          this.rollUsers = list.slice()
        }, 50)
      },
      stop_CJ(){
         if (this.isfatch == true) {
          this.$message.error('点击太快了，稍等片刻')
       
          return false
        }
        this.isfatch = true;
        postPrizeAfter({
					  lid: this.lottery_id,
            ldid: this.manualDetail.id,
				},this.$cookie.getCookie('token')).then(res => {
          console.log(res);
          this.isfatch = false;
          if(res.data.code == 200) {
            $("#Running")[0].pause();
		   			setTimeout(function () {
                $("#Winning")[0].currentTime=0;
                $("#Winning")[0].play();
            }, 150); 
           this.isShowBtn=false;	
	         this.ismidend=true;
	         this.isdoing=false;
	         this.isShowRoll=false;
            this.winUser = res.data.data.wins;
            this.currDetail = res.data.data.curr;
            if (this.rolltimer) {
              clearInterval(this.rolltimer)
              this.rolltimer = null;
            }
            this.rollUsers = this.winUser;
            console.log(this.rollUsers);

            if (res.data.data.next && res.data.data.next.id) {
              this.manualDetail = res.data.data.next;
            
            }
            if (res.data.data.next && res.data.data.next.id) {
              this.manualDetail= res.data.data.next;
            }
            if (res.data.data.next && res.data.data.next.id) {
              //没有结束
              var obj = res.data.data;
              obj.prizetitle = res.data.data.next.name
              obj.currDetail = res.data.data.curr
              obj.btnName = '等待主持人开奖'
              obj.ismidend = true
              obj.isdoing = false
              obj.isallend = false
              obj.showtitle = false
              obj.runs = 3

              if (
                res.data.data.curr.round !=
                res.data.data.curr.complete_round
              ) {
                //当前奖项 没有抽完 直接继续 而不是提示开始
                this.isContinue = true  //继续抽 点击开始滚动
                this.isTipsEnd = false
                obj.isContinue = true
                obj.isTipsEnd = false
              } else {
                //当前奖项 已全部抽完  点击继续 而不是提示开始按钮
                //应该提示 当前奖项已经抽完的提示
                this.isContinue = false //显示开始按钮  提示开始按钮
                this.isTipsEnd = true
                obj.isContinue = false
                obj.isTipsEnd = true
              }
              //Lists/:id / send / 发送通知
              this.pushCS(obj)
              this.iskj = true;
              this.showWinSmallList= true;
              this.ismidend = true;
              this.btnName = '继续抽奖';
              this.prizetitle = res.data.data.next.name;
              this.showtitle = false;
            } else {
              //已经结束
              this.iskj = true;
              this.showWinSmallList= true;
              this.currDetail = res.data.data.curr;
              this.btnName = '查看中奖名单';
              this.ismidend = true;
              this.isallend = true;
              this.isTipsEnd = true;
              this.status = 2;
              var obj = res.data.data;
              obj.currDetail = res.data.data.curr
              obj.btnName = '查看抽奖结果'
              obj.ismidend = true
              obj.isallend = true
              obj.showtitle = false
              obj.runs = 0
              obj.status = 2

              ///Lists/:id / send / 发送通知
              this.pushCS(obj)
              // var getRequest = wxRequest.getRequest(Api.manualComplete({ id: this.data.lid }));
              // getRequest
              //   .then(res => {
              //     if (res.data.code == 200) {
              //       console.log('确认结束')
              //     }
              //   })
          }

          } else {
            this.$message.error(res.data.msg)
          }


				
				})  
        // if (this.rolltimer) {
        //   clearInterval(this.rolltimer)
        //   this.rolltimer = null
        // }
        // console.log(this.rollUsers);

      },
      	//通知客户端 
			pushCS(obj) {
				///Lists/:id / send /
				this.socket.emit('messagev2', {
					"obj": this.id,
					"data": obj
				});
			},

			
      handleUploadSuccess(res) {
      if (res.code === 200) {
        var obj = {
          bg: res.data.imgurl,
          title: '自定义皮肤'
        }
        postDzpSkin(obj, this.$cookie.getCookie('token')).then(
          response => {
            console.log(response.code)
            if (response.code === 200) {
              this.fetchSkinList()
              this.$message.success('上传成功，请选择您的皮肤吧')
            } else {
              this.$message.error(response.data.msg)
            }
          },
          reject => {
            console.log(reject)
            this.$message.error(reject.data.msg)
          }
        )
      }
    },
    changeSkin() {
      if (this.$cookie.getCookie('token') === '') {
        console.log(this.$cookie.getCookie('token'))
        this.$refs.login.login_fn()
        return false
      }
      this.skinDIYShow = true
      this.fetchSkinList()
    },
    setSKinHander(index) {
      this.skinIndex = index
      this.skinDIYShow = false
      this.fullHandle()
    },
    skinCloseHander() {
      this.skinDIYShow = false
    },
    hideWinListHander() {
      this.showWinList = false;

      this.showWinner=false;
    },
    resize(newRect) {
      this.width = newRect.width
      this.height = newRect.height
      this.top = newRect.top
      this.left = newRect.left
      this.qrCodeScale = this.width / 480
    },
    showWinListHander() {
      this.fetchPrize()
    },
    quiteHandle(){
				if (document.exitFullscreen) { 
				    document.exitFullscreen(); 
				} 
				else if (document.mozCancelFullScreen) { 
				    document.mozCancelFullScreen(); 
				} 
				else if (document.webkitCancelFullScreen) { 
				    document.webkitCancelFullScreen(); 
				}
				else if (document.msExitFullscreen) {
				      document.msExitFullscreen();
				}
			},
    setScale() {
      if ($(window).width() <= 1920) {
        $('.full-body').css({
          transform:
            'scale(' + $(window).width() / 1920 + ') translate(-50%, -50%)',
          'transform-origin': '0 top'
        })
      } else {
        $('.full-body').css({
          transform: 'scale(1)translate(-50%, -50%)',
          'transform-origin': '0 top'
        })
      }
      if ($(window).width() <= 1552) {
        $('.winning-list').css({
          transform: 'scale(' + $(window).width() / 1552 + ')',
          'transform-origin': '0 center'
        })
      } else {
        $('.winning-list').css({
          transform: 'scale(1)',
          'transform-origin': '0 center'
        })
      }
    },
    fullHandle() {
      var docElm = document.documentElement
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
    },
    fetchSkinList() {
      getDZPSkinList({ }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          this.skinList = res.data.data
        } else {

        }
      })
    },
    MoreWinListHander(citem, index) {
      getPrizePage({ lid: this.lottery_id, ldid: citem.ldid, page: citem.page - 0 + 1 }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data.prize_user_list.length > 0) {
            this.winLists[index].prize_user_list = this.winLists[index].prize_user_list.concat(res.data.data.prize_user_list)
            this.winLists[index].page++
            if (res.data.data.prize_user_list.length === 12) {
              this.winLists[index].fetch = false
            } else {
              this.winLists[index].fetch = true
            }
          } else {
            this.winLists[index].fetch = true
          }
        } else {

        }
      })
    },
    musicClick() {
      this.musicPlay = !this.musicPlay
      // this.$refs.audio1.play()
      // console.log(this.$refs.player)
      if (this.musicPlay) {
        this.$refs.player.play()
      } else {
        this.$refs.player.pause()
      }
    },
    fetchQrcode() {
      if (this.$cookie.getCookie('token') === '') {
        console.log(this.$cookie.getCookie('token'))
        this.$refs.login.login_fn()
        return false
      }
      if (!this.ewm) {
        var url
        if (this.detail.prize_type == '1' || this.detail.prize_type == '2') {
          url = encodeURIComponent('pages/autolottery/detail')
        } else if (this.detail.prize_type == '3') {
          url = encodeURIComponent('pages/share/share')
        } 
        getQcode({ lid: this.lottery_id, page: url,isShowSplashAd:true }, this.$cookie.getCookie('token')).then((res) => {
          if (res.data.code === 200) {
            this.ewm = res.data.data.invite_qrcode
            this.showQcode = true
          } else {

          }
        })
      } else {
        this.showQcode = true
      }
    },
    seeALL(type){
      if(type!='end'){
        $("#Running")[0].pause();
        $("#Winning")[0].pause();
        setTimeout(function () {
            $("#Winover")[0].play();
          }, 150);
        }
		   	this.winLists=[];
        this.fetchPrize();

    },
    fetchPrize() {
      if (this.$cookie.getCookie('token') === '') {
        console.log(this.$cookie.getCookie('token'))
        this.$refs.login.login_fn()
        return false
      }
      getPrizeList({ lid: this.lottery_id }, this.$cookie.getCookie('token')).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          res.data.data.forEach((v, i) => {
            v.page = 1
            v.fetch = false
          })
          this.iskj=false;
          this.isuserkj=false;
          this.showWinSmallList = false;
          this.showWinner=true;
          this.isShowBtn=false;
          this.winLists = res.data.data
          this.showWinList = true
        } else {

        }
     })
    },
    fetchDetail(){
      getGroupLotteryDetail({lid:this.lottery_id}, this.$cookie.getCookie('token')).then(res => {
        console.log(res);
        if(res.code == 200){
        
          this.detail  = res.data;
         
          if(res.data.status==2){
            this.status = res.data.status;
            this.isShowBtn=false;
            this.seeALL('end');
          }
          if(res.data.status==1){
            this.status =0;

          }

          setTimeout(() => {
            this.swiper = new Swiper('.swiper-container', {
              effect: 'coverflow',
              grabCursor: true,
              centeredSlides: true,
              slidesPerView: 'auto',
              autoplay: {
                delay: 3000 // 1秒切换一次
              },
              // loop: true,
              coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
              }
            })
          }, 1500)

          if(this.detail.prize_type == 2){
            this.timer3 = setInterval(() => {
              console.log('定时获取已参与人数详情')
              getGroupLotteryDetail({lid:this.lottery_id}, this.$cookie.getCookie('token')).then(res => {
                console.log(res);
                if(res.code == 200){
                  this.detail.total_join_num = res.data.total_join_num;

                }
              })

            }, 10000)
          }

          
        
        } else {
          this.$message && this.$message.error(res.msg || '获取抽奖详情失败')
        }
      }).catch(err => {
        console.error('getGroupLotteryDetail error', err)
      })
    },
    formatTime(ts) {
      if (!ts) return ''
      const d = new Date(ts * 1000)
      const pad = (n) => (n < 10 ? '0' + n : n)
      const Y = d.getFullYear()
      const M = pad(d.getMonth() + 1)
      const D = pad(d.getDate())
      const h = pad(d.getHours())
      const m = pad(d.getMinutes())
      const s = pad(d.getSeconds())
      return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    fetchData(){
      console.log('fetchData');
      this.fetchDetail();
    },
  },
  created() {
    this.lottery_id = this.$route.query.id
    if (this.$cookie.getCookie('token') === '') {
      this.$refs.login.login_fn()
      return
    }
    this.fetchDetail()
    this.socket.on('connect', () => {
      console.log('wss 已链接')
      this.isconnect = true
    })
    this.socket.on('disconnect', (reason) => {
      console.log('wss 已断开')
    })
    this.socket.open()
    var time = setInterval(() => {
      console.log('11111')
      console.log(this.isconnect)
      if (this.isconnect === true) {
        // 加入房间
        this.socket.emit('joinroom', 'qcj' + this.lottery_id)
        // 接受wws 信息
        this.socket.on('qcj' + this.lottery_id, (res) => {
          console.log('收到服务器内容：' + res)
          console.log(res)
          var response = res;
          if(response != undefined) {

              if(response.id != undefined && response.username != undefined) {
                
                this.detail.join_user_list.unshift(response);
                this.detail.total_join_num = parseInt(this.detail.total_join_num) + 1;
                  

              }
              		//作为创建者 接受wss
                  //一些注释
                // runs =1 客户端弹框
                // runs =2 客户端 开始滚动
                // runs =3 客户端 停止 显示中奖名单
                // runs =0 客户端关闭弹窗
								if (this.isCreator == 0) {
                    if (response.runs == 1) {
                      this.manualDetail = response;
                      this.prizetitle = response.prizetitle;
                      this.joinUsers = response.users;
                      this.ismidend = false;
                      this.showtitle = response.showtitle;
                      this.ismidend = true;
                      this.btnName = response.btnName;
                      this.isContinue = response.isContinue;
                      this.isTipsEnd = response.isTipsEnd;
                      this.rollUsers = [];
                      this.status = 1;
                      this.iskj=false;
                      this.isuserkj=false;
                      this.showWinSmallList= false;
                      this.rollUsers = [];
                      this.isShowBtn = false;
                      $("#Running")[0].pause();
		                	$("#Winning")[0].pause();
                    }
                    if (response.runs == 2) {
                      this.ismidend = false;
                      this.isdoing = false;
                      this.btnName = response.btnName;
                      this.isuserkj = true;
                      this.showtitle = response.showtitle;
                      this.isShowBtn = false;
                      this.rollWinusers(this.manualDetail.users);
                      setTimeout(function () {
                        $("#Running")[0].currentTime=0;
                        $("#Running")[0].play();
                      }, 150);

                    }
                    if (response.runs == 3) {
                      this.manualDetail = response.next;
                      this.currDetail = response.currDetail;
                      this.isuserkj = true;
                      this.showtitle = response.showtitle;
                      this.ismidend = true;
                      this.isdoing = false;
                      this.btnName = response.btnName;
                      this.isallend = response.isallend;
                      this.winUser = response.wins;
                      this.status = response.status;
                      this.isShowBtn = false;
                      $("#Running")[0].pause();
                      setTimeout(function () {
                          $("#Winning")[0].currentTime=0;
                          $("#Winning")[0].play();
                      }, 150); 
                      if (this.rolltimer) {
                        clearInterval(this.rolltimer)
                        this.rolltimer = null;
                      }
                      this.rollUsers = this.winUser;
                      this.showWinSmallList = true;
                      console.log(this.rollUsers);

                      if (
                        response.curr.round !=
                        response.curr.complete_round
                      ) {
                        this.isContinue = true;
                        this.isTipsEnd = false;
                        //当前奖项 没有抽完 直接继续 而不是提示开始
                      } else {
                        this.isContinue = false;
                        this.isTipsEnd = true;
                      }
                      // _this.refreshPrizeDetail(_this.data.lid);
                    }
                    if (response.runs == 0) {
                      this.currDetail = response.currDetail;
                      this.isuserkj = true;
                      this.showtitle = response.showtitle;
                      this.ismidend = true;
                      this.isdoing = false;
                      this.btnName = response.btnName;
                      this.isallend = response.isallend;
                      this.winUser = response.wins;
                      this.status = response.status;
                      this.isTipsEnd = true;
                      $("#Running")[0].pause();
                      setTimeout(function () {
                          $("#Winning")[0].currentTime=0;
                          $("#Winning")[0].play();
                      }, 150); 
                      if (this.rolltimer) {
                        clearInterval(this.rolltimer)
                        this.rolltimer = null;
                      }
                      this.rollUsers = this.winUser;
                      this.showWinSmallList = true;
                      console.log(this.rollUsers);
                  
                    }
		              }	
          }

          // if (res.setType === 'win') {
          //   this.detail.detail.forEach((v, i) => {
          //     if (res.prize_id === v.id) {
          //       res.prize = v.name
          //       res.desc = v.desc
          //       res.cover = v.cover
          //       v.hasnum = v.hasnum - 0 + 1
          //     }
          //   })
          //   this.detail.detail = this.detail.detail
          //   this.$forceUpdate()
          //   // 收到中奖通知
          //   this.wins.push(res)
          //   setTimeout(() => {
          //     this.$refs.winBoxScroll.scrollTop = this.$refs.winBoxScrollUl.offsetHeight - 576
          //   }, 500)
          //   console.log(this.wins)
          // }
        })
        clearInterval(time)
      }
    }, 2500)

  },
   destroyed() {
    if (this.timer) clearInterval(this.timer)
    if (this.timer2) clearTimeout(this.timer2);
    if (this.timer3) clearTimeout(this.timer3);
    if (this.rolltimer) clearInterval(this.rolltimer);
    this.socket.emit('leaveroom', 'qcj' + this.lottery_id)
    // window.removeEventListener('hashchange', this.afterQRScan);
  },
  mounted() {
    var _this = this
    this.now = Math.floor(Date.now() / 1000)
    this.timer = setInterval(() => {
      this.now = Math.floor(Date.now() / 1000)
    }, 1000)
    this.$nextTick(() => {
      $(function () {
        _this.setScale()
        _this.left = $(window).width() / 2
        _this.top = $(window).height() / 2 - 550
        setTimeout(() => {
          // console.log(_this.$refs.winBoxScrollUl.offsetHeight)
          // console.log(_this.$refs.winBoxScroll.scrollTop = _this.$refs.winBoxScrollUl.offsetHeight - 576)
          _this.$refs.winBoxScroll.scrollTop = _this.$refs.winBoxScrollUl.offsetHeight - 576
          // console.log($)
          // console.log($('#winBoxScroll'))
          // console.log($('#winBoxScroll ul'))
          // console.log($('#winBoxScroll ul').offsetHeight)
          // $('#winBoxScroll').scrollTop = '1440px'
          // $('#winBoxScroll').scrollTop = $('#winBoxScroll ul').offsetHeight
        }, 1500)
      })
      $(window).resize(() => {
        _this.setScale()
      })
    })
  }
}

</script>


<style scoped rel="stylesheet/scss" lang="scss">
@import url('../assets/css/base.min.css');
@import url('../assets/css/xccjScreen.min.css');
@import url('../assets/css/vueDragResize.min.css');

.prize_title{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 20px;
  width: 100%;
}

.playerList {
  .noData {
    text-align: center;
    color: #ffffff;
    margin-bottom: 20px;

  }
}

.morePlayer {
  color: #ffffff;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}
.skin_mask{
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha:0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
.skinBox{
  width: 80%;
  position: fixed;
  left: 0;
  right: 0;
  height: 80vh;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  background: #f2f2f2;
  z-index: 100;
  border-radius: 20px;
  overflow-y: auto;
  .skinItems{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    padding:10px 30px;
    border-radius: 30px;
    .skinItem{
      background: #ffffff;
      width: 250px;
      height: 180px;
      margin: 30px;
      border: 2px solid #d5d5d5;
      box-shadow: 1px 1px 30px rgba($color: #000000, $alpha: 0.3);
      border-radius: 10px;
      overflow: hidden;
      &.active{
        border: 2px solid saddlebrown;
        background: saddlebrown;
        box-shadow: 1px 1px 30px rgba($color: saddlebrown, $alpha: 0.5);
        .title{
          color: #ffffff;
        }
      }
      .imgbox{
        width: 250px;
        height: 130px;
        overflow: hidden;
        position: relative;
        img{
          width: 100%;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .title{
        height:50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        color: #666;
      }
    }
  }
  .closeBtn{
    width: 28px;
    height: 28px;
    position: absolute;
    right: 10px;
    top: 10px;
    img{
      width: 28px;
      height: 28px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/nomarlDetail.vue